export const selectAppIsInitialized = state => state.app.isInitialized;
